module.exports = __webpack_public_path__ + "img/Maps.2e8aef67.png";